var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply_financing"},[_c('a',{on:{"click":_vm.toApply}},[_c('img',{attrs:{"src":require("../static/img/rz.png"),"alt":"我要融资"}}),_vm._v(" "),_c('div',[_vm._v("申请融资")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd5f058","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplyFinancing.vue
// module id = null
// module chunks = 